<script setup>
import BaseButton from '@dogfy/components/base/BaseButton.vue'

import config from '@/config'

const oAuthProviders = Object.entries(config.oAuthProviders).map(([provider, { label, icon }]) => ({ label, value: provider, icon }))

async function redirectToOAuthProvider (providerId) {
  const { baseUrl, clientId, redirectUri } = config.oAuthProviders[providerId]

  const params = new URLSearchParams({
    client_id: clientId,
    redirect_uri: redirectUri,
    response_type: 'code',
    response_mode: providerId === 'apple' ? 'form_post' : 'query',
    scope: 'email',
    access_type: 'offline',
    prompt: 'select_account',
  })

  window.open(`${baseUrl}?${params.toString()}`, '_self')
}
</script>

<template>
  <div class="social-login">
    <hr class="social-login__hr">
    <div class="social-login__providers">
      <BaseButton
        v-for="provider in oAuthProviders"
        :key="provider.value"
        type="small fullwidth secondary"
        :icon="provider.icon"
        @click="redirectToOAuthProvider(provider.value)"
      >
        {{ provider.label }}
      </BaseButton>
    </div>
  </div>
</template>

<style lang="scss">
.social-login {
  display: flex;

  flex-direction: column;
  gap: $spacer-double;
  align-items: center;
  justify-content: center;

  width: 100%;

  &__hr {
    position: relative;

    display: flex;

    align-items: center;
    justify-content: center;

    overflow: visible;

    width: 100%;
    height: 0;

    border-top: $border-weight-hairline solid $color-neutral-semidark;

    &::after {
      content: 'o';

      padding: 0 $spacer*1.5;

      background-color: $color-neutral-white;

      font-size: ms(1, true);
      line-height: $font-lineheight-large;
      font-weight: $font-weight-regular;
      color: $color-neutral-dark;
    }
  }

  &__providers {
    display: flex;

    flex-direction: column;
    gap: $spacer;
    justify-content: space-between;

    width: 100%;

    @include breakpoint(lg) {
      flex-direction: row;
      gap: $spacer-half;
    }
  }
}
</style>
